(function () {
    "use strict";

    Controllers.OneFlowController = class OneFlowController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, UsersManager, AppStates, $state, FeaturesService) {
            super($scope, $injector);
            this.__objectType = 'OneFlowController';

            this.user = UsersManager.getCurrUser();

            if (!this.user.isFeatureActive(FeaturesService.rolloutFeatures.oneFlowTemplates)) {
                $state.go(AppStates.root_core_navigation_home);
            }
        }
    };

}());
